import { Divider, Paper, Tab, Tabs } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import CustomDataGridFilterToolbar from "../../../common/js/components/CustomDataGridFilterToolbar";
import CorporateDataDealsGrid from "./CorporateDataDealsGrid";

const StyledPageToolbar = styled("div")({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    marginBottom: "20px",
    marginTop: "20px",
});

const StyledTabs = styled(Tabs)({
    borderBottom: "none",
    marginRight: "20px",
    position: "absolute",
    bottom: 0,
    width: "30em",
});

const StyledTab = styled(Tab)({
    borderBottom: "none",
    marginRight: "20px",
});

const StyledPaperSpacing = styled(Paper)({
    padding: "10px 20px",
    fontSize: 14,
    marginBottom: "15px",
});

const StyledDivider = styled(Divider)({
    backgroundColor: "rgba(0, 0, 0, 0.06)",
    margin: "0 -20px 0 -20px",
});

const StyledPaperContainer = styled("div")({
    display: "flex",
    justifyContent: "space-between",
});

const StyledFilter = styled("div")({
    padding: "8px",
});

const StyledTabsContainer = styled("div")({
    position: "relative",
    padding: "8px",
});

const CorporateDataDeals = (props) => {
    const {
        auth,
        deals,
        dealView,
        getCorporateDataOpenDeals,
        getCorporateDataUnassignedDeals,
        setDealsFilter,
        setDealsPage,
        switchDealView,
    } = props;

    const corporateDataDeals = deals[dealView];
    const isUnassignedDealsView = dealView === "data_entry_unassigned";

    const filterColumns = [
        { field: "dealName", label: "Deal Name", type: "plaintext" },
        { field: "addressLine", label: "Address Line", type: "plaintext" },
        { field: "city", label: "City", type: "plaintext" },
        { field: "state", label: "State", type: "plaintext" },
        { field: "zipCode", label: "ZipCode", type: "plaintext" },
        { field: "brokers", label: "Broker", type: "plaintext" },
        { field: "totalCommission", label: "Total Commission", type: "currency" },
        { field: "dealStatus", label: "Status", type: "plaintext", hide: isUnassignedDealsView },
        { field: "action", label: "Action", type: "plaintext" },
    ];

    const getCorporateDataDeals = () => {
        if (isUnassignedDealsView) {
            getCorporateDataUnassignedDeals();
        } else {
            getCorporateDataOpenDeals(auth.userProfile.user);
        }
    };

    return (
        <React.Fragment>
            <StyledPageToolbar>
                <h2 className="page-title">Deals</h2>
            </StyledPageToolbar>

            <StyledPaperSpacing>
                <StyledPaperContainer>
                    <StyledTabsContainer>
                        <StyledTabs value={dealView} onChange={switchDealView} indicatorColor="primary">
                            <StyledTab value="data_entry_unassigned" label="Unassigned Deals" />
                            <StyledTab value="data_entry_open" label="Open Deals" />
                        </StyledTabs>
                    </StyledTabsContainer>
                    <StyledFilter>
                        <CustomDataGridFilterToolbar
                            key={dealView}
                            fields={filterColumns}
                            setFilter={setDealsFilter}
                            setPage={setDealsPage}
                            onSubmit={getCorporateDataDeals}
                        />
                    </StyledFilter>
                </StyledPaperContainer>
                <StyledDivider />
                <CorporateDataDealsGrid
                    key={dealView}
                    dealView={dealView}
                    getCorporateDataDeals={getCorporateDataDeals}
                    corporateDataDeals={corporateDataDeals}
                    {...props}
                ></CorporateDataDealsGrid>
            </StyledPaperSpacing>
        </React.Fragment>
    );
};

export default CorporateDataDeals;
